import { Obj, Str } from '@livecontrol/core-utils';
import { Errors } from '@livecontrol/scheduler/store';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { store } from '../factory';

interface TVariables {
  email: string;
  code: string;
  password: string;
}

type Args = TVariables;

export const useConfirmForgotPassword = (): [
  (args: Args) => void,
  {
    error?: Error;
    loading: boolean;
  }
] => {
  const history = useHistory();
  const { environment } = store.getState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();

  return [
    useCallback(
      (args: Args): void => {
        try {
          // Parse the input arguments
          const variables = {
            code: Str.normalize(args.code),
            password: Str.normalize(args.password),
            Username: Str.normalize(args.email)
          };

          // Validate the input
          if (!Obj.isHydrated(variables)) {
            throw Errors.badRequest();
          }

          setLoading(true);

          const poolData = {
            UserPoolId: environment.COGNITO_POOL_ID,
            ClientId: environment.COGNITO_APP_CLIENT_ID
          };

          const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

          const userData = {
            Username: variables.Username,
            Pool: userPool
          };

          const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

          const callbacks = {
            onSuccess: (): void => {
              setLoading(false);
              history.push('/login');
            },
            onFailure: (err: unknown): void => {
              setError(<Error>err);
              setLoading(false);
            }
          };

          cognitoUser.confirmPassword(variables.code, variables.password, callbacks);
        } catch (error_: unknown) {
          setError(<Error>error_);
          setLoading(false);
        }
      },
      [environment, history]
    ),
    {
      error,
      loading
    }
  ];
};
